import PropTypes from 'prop-types';
import React from 'react';
import Stars from '../_generic/stars/Stars';

const Review = ({ deal }) => {
  return (
    <>
      {deal?.reviewSummary?.total > 0 && (
        <div className="reviews">
          <Stars value={deal.reviewSummary.average} />{' '}
          {`(${deal.reviewSummary.total} ${
            deal.reviewSummary.total > 1 ? 'Reviews' : 'Review'
          })`}
        </div>
      )}
      <style jsx>{`
        .reviews {
          color: #999999;
          font-size: 14px;
          margin: 0 15px;
          text-decoration: none;
        }
      `}</style>
    </>
  );
};

export default Review;

Review.propTypes = {
  deal: PropTypes.object,
};
